
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import RichTextEditor from "../../../Components/Editor/RichTextEditor";

// Redux
import { useSelector } from "react-redux";

// Service
import ItemService from "../../../services/supplier_appCommonService";

// Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { MultiselectField } from "../../../Components/formElements/MultiselectField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
// import { checkTimeDifference } from "../../../common/Validations";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import BuyerAuctionFormModal from "./BuyerAuctionFormModal";
import PageLevelRiverseTimer from "../../../Components/PageLevelRiverseTimer";
import useAuctionSocket from "../../../hooks/useAuctionSocket";
import LiveBidFeed from "../../../Components/Auction/LiveBidFeed";
import moment from "moment";
import BidSubmitPanel from "../../../Components/Auction/BidSubmitPanel";
import LiveAuctionDashboard from "../../../Components/Auction/LiveAuctionDashboard";

const LiveReverseAuctionDetail = () => {
  let auctionId = useSelector(
    (state) => state.eauctionSlice.eauction.auctionNr
  );

  //  Tab state 
  const [activeTab, setActiveTab] = useState(1);
  const totalTabs = 6;
  const tabLabels = [
    { id: 1, label: "Auction Creation", icon: "bi-info-circle" },
    { id: 2, label: "Configuration",    icon: "bi-gear" },
    { id: 3, label: "Add Item",         icon: "bi-box" },
    { id: 4, label: "Suppliers",        icon: "bi-people" },
    { id: 5, label: "Price",            icon: "bi-currency-dollar" },
    { id: 6, label: "Schedule",         icon: "bi-calendar3" },
  ];

  //  Accordion visibility 
  const [isCardVisible2,  setCardVisible2]  = useState(true);
  const [isCardVisible5,  setCardVisible5]  = useState(true);
  const [isCardVisible6,  setCardVisible6]  = useState(true);
  const [isCardVisible7,  setCardVisible7]  = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const toggleCardVisibility2  = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility5  = () => setCardVisible5(!isCardVisible5);
  const toggleCardVisibility6  = () => setCardVisible6(!isCardVisible6);
  const toggleCardVisibility7  = () => setCardVisible7(!isCardVisible7);
  const toggleCardVisibility10 = () => setCardVisible10(!isCardVisible10);

  //  Dropdown helper 
  const [getDropdownData, setDropdownData] = useState("");

  //  Master data 
  const [getcurrency,      setcurrency]      = useState([]);
  //eslint-disable-next-line
  const [selectedINCOTerms, setSelectedINCOTerms] = useState([]);

  //  Form inputs (loaded from API) 
  const [formInputs, setFormInputs] = useState({});

  //  Open/close schedule 
  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour:   "",
    status:      false,
    msg:         "",
  });

  //  Line items 
  const lineItemsDataDefault = [
    {
      local_id: 1,
      itemCategory: "",
      itemNo: "",
      itemCode: "",
      itemDescription: "",
      uom: "",
    },
  ];
  const [getLineItemstData, setLineItemsData] = useState(lineItemsDataDefault);

  //  Bidders 
  const biddersDefault = [
    {
      local_id: 1,
      supplierCodeAndName: "",
      country: "",
      emailId: "",
      contactNo: "",
      userId: "",
    },
  ];
  const [getBiddersData, setBiddersData] = useState(biddersDefault);

  //  Supplier list (Tab 4) 
  const [getSupplierData, setSupplierData] = useState([]);

  //  Editor 
  //eslint-disable-next-line
  const [editorContent, setEditorContent] = useState("");

  //  File viewer 
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData,      setFileViewData]      = useState(null);
  const handleViewFile    = (id) => { setFileViewData(id); setShowFileViewModal(true); };
  const handleViewFileHide = ()  => setShowFileViewModal(false);

  //  Modals 
  const modalData = { title: "Auction Detail", successMsg: "" };
  //eslint-disable-next-line
  const [getModalInfo,        setModalInfo]        = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const hideSuccessModal = () => setShowSuccessModal(false);

  const failureModalData = { title: "Warning", ErrorMsg: "" };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  //eslint-disable-next-line
  const [getErrorFields,      setErrorFields]      = useState([]);
  const [getFailureModal]                          = useState(failureModalData);
  const hideFailureModal = () => setShowFailureModal(false);

  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] = useState(false);
  const hideModalStatus = () => setCreateDynamicformModelShow(false);

 
  //eslint-disable-next-line
  const [getItemLevelData,    setItemLevelData]    = useState([]);
    //eslint-disable-next-line
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
    //eslint-disable-next-line
  const [getModalTitle,       setModalTitle]       = useState("");
  const [itemLevelModalShow,  setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => setItemLevelModalShow(false);

  //  Timer 
  const [finalTimerValue, setFinalTimerValue] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [itemLeaderboard, setItemLeaderboard] = useState([]);
  const [isAuctionClosed, setIsAuctionClosed] = useState(false);

  useEffect(() => {
    if (formInputs?.deliveryStatusHeader === "Closed" && formInputs?.auctionStatus === "Ended") {
      setIsAuctionClosed(true);
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else if (formInputs?.deliveryStatusHeader === "Published" || formInputs?.auctionStatus === "Publish") {
      setIsAuctionClosed(false);
    }
  }, [formInputs]);

  const updateTimerValue = (closingDateTime) => {
    if (!closingDateTime) {
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }
    // Use moment with local timezone parsing
    const closingMoment = moment(closingDateTime);
    const now = moment();
    const diff = closingMoment.diff(now);
    if (diff <= 0) {
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else {
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (24 * 60 * 60));
      const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;
      setFinalTimerValue({ days, hours, minutes, seconds });
    }
  };

  //  Socket
  const {
    isConnected:        socketConnected,
    liveBids,
    liveBidRanking,
    auctionStatus:      socketAuctionStatus,
    onlineSuppliers,
    emitRequestLeaderboard,
    serverRemainingSeconds,
    auctionExtendedData,
    serverBidTimings,
  } = useAuctionSocket(auctionId, "buyer");

  // Compute actual ended status - considers both socket status and remaining time
  const isActuallyEnded = isAuctionClosed || (socketAuctionStatus === "ended" && (serverRemainingSeconds === null || serverRemainingSeconds <= 0));

  // Set isAuctionClosed when socket reports ended AND time has expired
  useEffect(() => {
    if (socketAuctionStatus === "ended" && (serverRemainingSeconds === null || serverRemainingSeconds <= 0)) {
      setIsAuctionClosed(true);
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else if (socketAuctionStatus === "extended") {
      setIsAuctionClosed(false);
    }
  }, [socketAuctionStatus, serverRemainingSeconds]);

  // Fallback moment-based timer — only runs until socket connects and provides status
  useEffect(() => {
    if (!socketConnected) return;
    if (isAuctionClosed || socketAuctionStatus === "ended") {
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }
    if (serverRemainingSeconds != null && serverRemainingSeconds >= 0) return;
    if (!getOpenCloseInput?.closingDate || !getOpenCloseInput?.closingTime) return;
    const closingDateTime = `${getOpenCloseInput.closingDate} ${getOpenCloseInput.closingTime}`;
    updateTimerValue(closingDateTime);
    const interval = setInterval(() => updateTimerValue(closingDateTime), 1000);
    return () => clearInterval(interval);
  }, [getOpenCloseInput, serverRemainingSeconds, isAuctionClosed, socketConnected, socketAuctionStatus]);

  useEffect(() => {
    if (!auctionExtendedData) return;
    if (auctionExtendedData.updatedBidTimings) {
      setFormInputs(prev => ({
        ...prev,
        bidTimings: auctionExtendedData.updatedBidTimings,
      }));
      return;
    }
      //eslint-disable-next-line
    const { extendedByMs, newEndTime, bidConfigType: extBidConfig } = auctionExtendedData;
    if (!extendedByMs && !newEndTime) return;

    setFormInputs(prev => {
      const now            = new Date();
      const updatedTimings = { ...(prev.bidTimings || {}) };
      const bidConfig      = prev.bidConfigType || "parallel";

      if (bidConfig === "serial") {
        const lotMap = {};
        Object.entries(updatedTimings).forEach(([key, timing]) => {
          const lotNo = String(timing?.lotNumber ?? "");
          if (!lotMap[lotNo]) lotMap[lotNo] = [];
          lotMap[lotNo].push(key);
        });

        const sortedLots     = Object.keys(lotMap).filter(l => l !== "").sort((a, b) => Number(a) - Number(b));
        let activeLotKey     = null;
        let activeLotNewEnd  = null;

        for (const lotKey of sortedLots) {
          const firstKey = lotMap[lotKey][0];
          const timing   = updatedTimings[firstKey];
          if (!timing) continue;
          const start = new Date(timing.startTime);
          const end   = new Date(timing.endTime);
          if (now >= start && now < end) {
            activeLotKey   = lotKey;
            activeLotNewEnd = extendedByMs
              ? new Date(end.getTime() + extendedByMs)
              : new Date(newEndTime);
            break;
          }
        }

        if (!activeLotKey) return prev;

        const activeLotIndex = sortedLots.indexOf(activeLotKey);

        lotMap[activeLotKey]?.forEach(key => {
          updatedTimings[key] = { ...updatedTimings[key], endTime: activeLotNewEnd };
        });

        for (let i = activeLotIndex + 1; i < sortedLots.length; i++) {
          const prevLotEnd  = new Date(updatedTimings[lotMap[sortedLots[i - 1]][0]]?.endTime);
          const currKeys    = lotMap[sortedLots[i]];
          const currTiming  = updatedTimings[currKeys[0]];
          const lotDuration = new Date(currTiming.endTime) - new Date(currTiming.startTime);
          currKeys.forEach(key => {
            updatedTimings[key] = {
              ...updatedTimings[key],
              startTime: prevLotEnd,
              endTime:   new Date(prevLotEnd.getTime() + lotDuration),
            };
          });
        }

      } else if (bidConfig === "staggered") {
        const itemsSorted = Object.entries(updatedTimings)
          .sort((a, b) => (a[1].serialNumber || 0) - (b[1].serialNumber || 0));

        let extendedIdx = -1;
        itemsSorted.forEach(([key, timing], idx) => {
          if (extendedIdx !== -1) return;
          const end = new Date(timing.endTime);
          if (now < end) {
            extendedIdx = idx;
            updatedTimings[key] = {
              ...timing,
              endTime: extendedByMs
                ? new Date(end.getTime() + extendedByMs)
                : new Date(newEndTime),
            };
          }
        });

        for (let i = extendedIdx + 1; i < itemsSorted.length; i++) {
          const [prevKey]              = itemsSorted[i - 1];
          const [currKey, currTiming]  = itemsSorted[i];
          const prevOrigEnd            = new Date(itemsSorted[i - 1][1].endTime);
          const currOrigEnd            = new Date(currTiming.endTime);
          const interval               = currOrigEnd - prevOrigEnd;
          const newPrevEnd             = new Date(updatedTimings[prevKey].endTime);
          updatedTimings[currKey] = { ...currTiming, endTime: new Date(newPrevEnd.getTime() + interval) };
        }
      }

      return { ...prev, bidTimings: updatedTimings };
    });
  }, [auctionExtendedData]);

  useEffect(() => {
    if (!serverBidTimings || Object.keys(serverBidTimings).length === 0) return;
    setFormInputs(prev => ({
      ...prev,
      bidTimings: serverBidTimings,
    }));
  }, [serverBidTimings]);

  useEffect(() => {
    if (!socketConnected) return;
    const t = setInterval(() => emitRequestLeaderboard(), 3000);
    return () => clearInterval(t);
  }, [socketConnected, emitRequestLeaderboard]);

  useEffect(() => {
    if (!auctionId) return;
    const fetchItemLeaderboard = async () => {
      try {
        const res = await ItemService.auctionGetItemLeaderboard({ auctionId });
        if (res?.data) setItemLeaderboard(res.data);
      } catch (e) {
        // silent
      }
    };
    fetchItemLeaderboard();
    const t = setInterval(fetchItemLeaderboard, 5000);
    return () => clearInterval(t);
  }, [auctionId]);

  useEffect(() => {
    if (serverRemainingSeconds != null) {
      const secs = Math.max(0, serverRemainingSeconds);
      setFinalTimerValue({
        days:    Math.floor(secs / 86400),
        hours:   Math.floor((secs % 86400) / 3600),
        minutes: Math.floor((secs % 3600) / 60),
        seconds: secs % 60,
      });
    }
  }, [serverRemainingSeconds]);

  const timerIntervalRef = React.useRef(null);
  const lastSyncRef      = React.useRef(null);

  useEffect(() => {
    if (serverRemainingSeconds == null || serverRemainingSeconds <= 0) return;
    if (socketAuctionStatus === "ended") return;

    lastSyncRef.current = { secs: serverRemainingSeconds, at: Date.now() };

    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);

    timerIntervalRef.current = setInterval(() => {
      if (!lastSyncRef.current) return;
      const elapsed  = Math.floor((Date.now() - lastSyncRef.current.at) / 1000);
      const remaining = Math.max(0, lastSyncRef.current.secs - elapsed);

      setFinalTimerValue({
        days:    Math.floor(remaining / 86400),
        hours:   Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      });

      if (remaining <= 0) {
        clearInterval(timerIntervalRef.current);
      }
    }, 1000);

    return () => { if (timerIntervalRef.current) clearInterval(timerIntervalRef.current); };
  }, [serverRemainingSeconds, socketAuctionStatus]);

  useEffect(() => {
    if (!getDropdownData?.textField) return;
    if (getDropdownData.textField === "auctionCurrencies") {
      setFormInputs((prev) => ({
        ...prev,
        auctionCurrencies:     getDropdownData.name,
        auctionCurrenciesCode: getDropdownData.code,
        auctionCurrenciesDesc: getDropdownData.description,
        auctionCurrencie:      getDropdownData.selected,
      }));
    } else if (getDropdownData.textField === "othercurrencies") {
      setFormInputs((prev) => ({
        ...prev,
        othercurrencies:     getDropdownData.name,
        othercurrenciesCode: getDropdownData.code,
        othercurrenciesDesc: getDropdownData.description,
        othercurrencie:      getDropdownData.selected,
      }));
    } else {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
        [getDropdownData.textCode]:  getDropdownData.code,
        [getDropdownData.textDesc]:  getDropdownData.description,
      }));
    }
  }, [getDropdownData]);

  //  Load page data 
  const loadInitialPageData = async () => {
    if (!auctionId) return;
    const toastId = toast.loading("Loading...", { position: "top-right" });
    try {
      const item = await ItemService.getAuctionDetail({ documentNumber: auctionId });
      if (item?.status === 200) {
        const res = item.data[0];
        setFormInputs(res);
        setOpenCloseInput({
          openingDate: res.openingDate || "",
          openingTime: res.openingTime || "",
          closingDate: res.closingDate || "",
          closingTime: res.closingTime || "",
        });
        if (res.instructions)   setEditorContent(res.instructions);
        if (res.incoTerms)      setSelectedINCOTerms(res.incoTerms);
        if (res.items)          setLineItemsData(res.items);
        if (res.bidders)        setBiddersData(res.bidders);
        if (res.supplierList)   setSupplierData(res.supplierList);

        const isClosedNow = res.deliveryStatusHeader === "Closed" && res.auctionStatus === "Ended";
        if (isClosedNow) {
          setIsAuctionClosed(true);
          setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        } else {
          setIsAuctionClosed(false);
          updateTimerValue(res?.closingDateTime);
        }
      } else {
        toast.error(item?.message || "Please try again !!", { duration: 4000, position: "top-right" });
      }
    } catch (err) {
      console.error("API call error:", err);
      toast.error("Something went wrong", { duration: 4000, position: "top-right" });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const getMasterDataFunc = async () => {
    const obj = { codeType: "currency" };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) setcurrency(item?.data);
      else setcurrency([]);
    });
  };

  useEffect(() => {
    getMasterDataFunc();
    loadInitialPageData();
    localStorage.setItem("menu", "eAuction");
    localStorage.setItem("submenu", "Reverse Auction");
      //eslint-disable-next-line
  }, [auctionId]);

  //  Send Invitation 
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);
  const handleSendInvitation = async () => {
    if (!auctionId) return;
    const toastId = toast.loading("Sending invitations...", { position: "top-right" });
    setIsSendingInvitation(true);
    try {
      const res = await ItemService.auctionSendInvitation({ auctionId });
      toast.dismiss(toastId);
      if (res?.status === 200) {
        const sent = res.data?.filter((d) => d.status === "sent").length || 0;
        toast.success(`Invitations sent to ${sent} supplier(s)`, { position: "top-right", duration: 4000 });
      } else {
        toast.error(res?.message || "Failed to send invitations", { position: "top-right" });
      }
    } catch { toast.dismiss(toastId); toast.error("Something went wrong", { position: "top-right" }); }
    finally { setIsSendingInvitation(false); }
  };

  //  Close Auction 
  const [isClosingAuction, setIsClosingAuction] = useState(false);
  const handleCloseAuction = async () => {
    if (!auctionId) return;
    if (!window.confirm("Are you sure you want to close this auction?")) return;
    const toastId = toast.loading("Closing auction...", { position: "top-right" });
    setIsClosingAuction(true);
    try {
      const res = await ItemService.auctionClose({ auctionId });
      toast.dismiss(toastId);
      if (res?.status === 200) {
        setIsAuctionClosed(true);
        setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        toast.success("Auction closed. Results emailed to suppliers.", { position: "top-right", duration: 5000 });
      } else {
        toast.error(res?.message || "Failed to close auction", { position: "top-right" });
      }
    } catch { toast.dismiss(toastId); toast.error("Something went wrong", { position: "top-right" }); }
    finally { setIsClosingAuction(false); }
  };

  //  Static dropdown data 
  const buyerCategories = [
    { id: 1, desc: "ProcurementDepartmentdesc", name: "Procurement Department", code: "ProcurementDepartmentcode" },
    { id: 2, desc: "PurchaseManagerdesc",        name: "Purchase Manager",        code: "PurchaseManagercode" },
    { id: 3, desc: "ProjectManagerdesc",         name: "Project Manager",         code: "ProjectManagercode" },
    { id: 4, desc: "FinanceDepartmentdesc",      name: "Finance Department",      code: "FinanceDepartmentcode" },
  ];

  const auctionTypeOptions = [
    { id: "Reverse", name: "Reverse Auction", description: "reverseAuction" },
    { id: "Forward", name: "Forward Auction", description: "forwardauction" },
    { id: "Ducth",   name: "Ducth Auction",   description: "ducthauction" },
    { id: "Package", name: "Package Auction", description: "packageauction" },
  ];

  //  Tab 3: Items columns (read-only) 
  const lineItemsColumns = [
    { name: "#",                selector: (row, i) => i + 1,                   width: "60px" },
    { name: "Item Category",    selector: (row) => row.itemCategory || "--",    width: "180px" },
    { name: "Item Name",        selector: (row) => row.itemNo || "--",          width: "180px" },
    { name: "Item Code",        selector: (row) => row.itemCode || "--",        width: "180px" },
    { name: "Item Description", selector: (row) => row.itemDescription || "--", width: "220px" },
    { name: "UOM",              selector: (row) => row.uom || "--",             width: "120px" },
  ];

  //  Tab 4: Suppliers columns (read-only) 
  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      cell: (row) => <button className="btnInfo">{row.AssociateNumber || "-"}</button>,
      width: "130px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => <TableStatusField status={row.status} />,
      width: "170px",
    },
    { name: "Supplier Name",   selector: (row) => row.organisationName         || "--", width: "200px" },
    { name: "SAP Number",      selector: (row) => row.sapAssociateNumber        || "--", width: "150px" },
    { name: "Contact Person",  selector: (row) => row.contactfirstName          || "--", width: "150px" },
    { name: "Contact Number",  selector: (row) => row.contactNumber             || "--", width: "150px" },
    { name: "Email",           selector: (row) => row.email                     || "--", width: "250px" },
    { name: "ICV Score %",     selector: (row) => row.totalScore                || "--", width: "150px" },
    { name: "Created Date",    selector: (row) => row.createdAt                 || "--", width: "160px" },
  ];

  //  Tab 4: Bidders columns (read-only) 
  const biddersColumns = [
    { name: "#",                       selector: (row, i) => i + 1,                         width: "60px" },
    { name: "Supplier Code and Name",  selector: (row) => row.supplierCodeAndName || "--",   width: "250px" },
    { name: "Country",                 selector: (row) => row.country             || "--",   width: "180px" },
    { name: "Email ID",                selector: (row) => row.emailId             || "--",   width: "250px" },
    { name: "Contact No",              selector: (row) => row.contactNo           || "--",   width: "180px" },
    { name: "User ID",                 selector: (row) => row.userId              || "--",   width: "180px" },
  ];

  //  Tab 5: Price config columns - NEW: includes quantity, MBD, reserve price 
  const priceConfigColumns = [
    { name: "#",                selector: (row, i) => i + 1,                    width: "60px" },
    { name: "Item Category",    selector: (row) => row.itemCategory    || "--",  width: "180px" },
    { name: "Item Name",        selector: (row) => row.itemNo          || "--",  width: "180px" },
    { name: "Item Code",        selector: (row) => row.itemCode        || "--",  width: "180px" },
    { name: "Description",      selector: (row) => row.itemDescription || "--",  width: "220px" },
    { name: "UOM",              selector: (row) => row.uom             || "--",  width: "120px" },
    // NEW: Quantity column
    {
      name: "Quantity",
      selector: (row) => formInputs.itemQuantities?.[row.local_id] || "--",
      cell: (row) => <span style={{ fontWeight: 600 }}>{formInputs.itemQuantities?.[row.local_id] || "--"}</span>,
      width: "120px",
    },
    // NEW: Per-item MBD column (show when mbdType != anyAmount)
    ...(formInputs.mbdType !== "anyAmount" ? [{
      name: "MBD",
      selector: (row) => formInputs.itemMbd?.[row.local_id] || "--",
      cell: (row) => <span style={{ fontWeight: 600, color: "#d97706" }}>{formInputs.itemMbd?.[row.local_id] || "--"}</span>,
      width: "100px",
    }] : []),
    // NEW: Per-item Reserve Price column
    {
      name: "Reserve Price",
      selector: (row) => formInputs.itemReservePrice?.[row.local_id] || "--",
      cell: (row) => <span style={{ fontWeight: 600, color: "#dc2626" }}>{formInputs.itemReservePrice?.[row.local_id] || "--"}</span>,
      width: "130px",
    },
    ...(formInputs.startPrice
      ? [{
          name: "Start Price",
          selector: (row) => formInputs.itemPrices?.[row.local_id] || "--",
          cell: (row) => (
            <span style={{ fontWeight: 600, color: "#1d4ed8" }}>
              {formInputs.itemPrices?.[row.local_id] || "--"}
            </span>
          ),
          width: "150px",
        }]
      : []),
    // NEW: Lot No / Seq # column (for Serial/Staggered)
    ...(formInputs.bidConfigType !== "parallel"
      ? [{
          name: formInputs.bidConfigType === "serial" ? "Lot No" : "Seq #",
          selector: (row) =>
            formInputs.bidConfigType === "serial"
              ? formInputs.bidTimings?.[row.local_id]?.lotNumber ?? "--"
              : formInputs.bidTimings?.[row.local_id]?.serialNumber ?? "--",
          cell: (row) => (
            <span style={{ fontWeight: 700, color: "#0f766e" }}>
              {formInputs.bidConfigType === "serial"
                ? formInputs.bidTimings?.[row.local_id]?.lotNumber ?? "--"
                : formInputs.bidTimings?.[row.local_id]?.serialNumber ?? "--"}
            </span>
          ),
          width: "100px",
        }]
      : []),
    // NEW: Supplier-wise initial prices (when FQ=Buyer mode)
    ...(formInputs.firstQuote && formInputs.firstQuoteBy === "Buyer"
      ? (getSupplierData || []).map((sup) => ({
          name: `${sup.organisationName || `Supplier ${sup.AssociateNumber}`}`,
          cell: (row) => (
            <span style={{ fontSize: "12px", fontWeight: 500 }}>
              {formInputs.supplierInitialPrices?.[sup.AssociateNumber]?.[row.local_id] || "--"}
            </span>
          ),
          width: "140px",
        }))
      : []),
  ];

  //  Shared readonly field style 
  const readonlyInputStyle = {
    width: "100%",
    padding: "8px",
    border: "1px solid #e5e7eb",
    borderRadius: "4px",
    fontSize: "13px",
    background: "#f9fafb",
    color: "#374151",
  };

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "4px",
    display: "block",
  };

  const ReadonlyField = ({ label, value }) => (
    <div>
      <label style={labelStyle}>{label}</label>
      <div style={readonlyInputStyle}>{value || "--"}</div>
    </div>
  );

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">

            {/* ── Page Header ── */}
            <h2 className="mainTitle">
              Live Reverse Auction Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {auctionId}
              </span>
            </h2>
            <p className="subText">Live Reverse Auction Details</p>
            <hr />

            {/* ── Buyer Action Buttons ── */}
            <Row className="mb-4">
              <Col xs={12}>
                <div style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "center",
                  padding: "14px 18px",
                  background: "linear-gradient(135deg, rgb(183, 216, 213), rgb(159, 199, 195));",
                  border: "1px solid #99d4cf",
                  borderRadius: "10px",
                }}>
                  <button
                    onClick={handleSendInvitation}
                    disabled={isSendingInvitation || isActuallyEnded || isAuctionClosed}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "8px",
                      padding: "9px 20px", border: "none", borderRadius: "8px",
                      background: isSendingInvitation || isActuallyEnded || isAuctionClosed
                        ? "#e5e7eb"
                        : "linear-gradient(135deg,#0f766e,#0d9488)",
                      color: isSendingInvitation || isActuallyEnded || isAuctionClosed ? "#9ca3af" : "#fff",
                      fontWeight: 700, fontSize: "13px",
                      cursor: isSendingInvitation || isActuallyEnded || isAuctionClosed ? "not-allowed" : "pointer",
                      boxShadow: "0 2px 8px rgba(15,118,110,0.25)",
                      transition: "all 0.2s",
                    }}
                  >
                    <span style={{ fontSize: "15px" }}>📧</span>
                    {isSendingInvitation ? "Sending..." : "Send Invitation"}
                  </button>

                  <button
                    onClick={handleCloseAuction}
                    disabled={isClosingAuction || isActuallyEnded || isAuctionClosed}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "8px",
                      padding: "9px 20px", border: "none", borderRadius: "8px",
                      background: isActuallyEnded || isAuctionClosed
                        ? "#e5e7eb"
                        : isClosingAuction ? "#fca5a5"
                        : "linear-gradient(135deg,#dc2626,#b91c1c)",
                      color: isActuallyEnded || isClosingAuction || isAuctionClosed ? "#9ca3af" : "#fff",
                      fontWeight: 700, fontSize: "13px",
                      cursor: isClosingAuction || isActuallyEnded || isAuctionClosed ? "not-allowed" : "pointer",
                      boxShadow: !isActuallyEnded && !isAuctionClosed ? "0 2px 8px rgba(220,38,38,0.25)" : "none",
                      transition: "all 0.2s",
                    }}
                  >
                    <span style={{ fontSize: "15px" }}>
                      {isActuallyEnded || isAuctionClosed ? "🔒" : "🏁"}
                    </span>
                    {isClosingAuction ? "Closing..."
                      : isActuallyEnded || isAuctionClosed ? "Auction Closed"
                      : "Close Auction"}
                  </button>

                  <div style={{ marginLeft: "auto" }}>
                    <span style={{
                      background: "#134e4a", color: "#a7f3d0",
                      padding: "6px 16px", borderRadius: "20px",
                      fontSize: "12px", fontWeight: 700, letterSpacing: "0.05em",
                    }}>
                      # {auctionId}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>

               {/*  Countdown Timer  */}
            <div style={{
              marginBottom: "20px",
              background: "linear-gradient(135deg, rgb(183, 216, 213), rgb(159, 199, 195));",
              borderRadius: "12px",
              padding: "16px 24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 4px 20px rgba(15,118,110,0.22)",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                <img
                  src="assets/img/stopwatch.png"
                  alt="stopwatch"
                  style={{ width: "48px", height: "48px", filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.3))" }}
                />
                <div>
                  <div style={{ color: "black", fontSize: "11px", fontWeight: 650, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                    Remaining Time for Submission
                  </div>
                  {getOpenCloseInput.closingDate && (
                    <div style={{ color: "black", fontSize: "12px", marginTop: "3px" }}>
                      Closes: <strong>{getOpenCloseInput.closingDate} {getOpenCloseInput.closingTime}</strong>
                    </div>
                  )}
                </div>
              </div>
              <PageLevelRiverseTimer timerData={finalTimerValue} />
            </div>

            {/*  Live Auction Dashboard  */}
            <LiveAuctionDashboard
              liveBids={liveBids}
              liveBidRanking={liveBidRanking}
              itemLeaderboard={itemLeaderboard}
              onlineSuppliers={onlineSuppliers}
              invitedSuppliers={getSupplierData}
              auctionStatus={socketAuctionStatus}
              closingDateTime={`${getOpenCloseInput.closingDate || ""} ${getOpenCloseInput.closingTime || ""}`}
              auctionExtendedData={auctionExtendedData}
              vendorMasking={formInputs?.vendorMasking === true}
              userRole="buyer"
              itemPrices={formInputs?.itemPrices || {}}
              itemReservePrice={formInputs?.itemReservePrice || {}}
              isAuctionClosed={isAuctionClosed}
            />

            {/* ── Live Bid Feed (Socket) ── */}
            <Row className="mb-4">
              {/* <Col xs={12}>
                <LiveBidFeed
                  liveBids={liveBids}
                  liveBidRanking={liveBidRanking}
                  isConnected={socketConnected}
                  auctionStatus={socketAuctionStatus}
                  userRole="buyer"
                  vendorMasking={formInputs?.vendorMasking === true}
                  displayRank={formInputs?.displayRank || "showToAll"}
                  onlineSuppliers={onlineSuppliers}
                  invitedSuppliers={getSupplierData}
                  itemLeaderboard={itemLeaderboard}
                  auctionId={auctionId}
                />
              </Col> */}
              <LiveBidFeed
  liveBids={liveBids}
  liveBidRanking={liveBidRanking}
  isConnected={socketConnected}
  auctionStatus={socketAuctionStatus}
  userRole="buyer"
  vendorMasking={formInputs?.vendorMasking === true}
  displayRank={formInputs?.displayRank || "showToAll"}
  onlineSuppliers={onlineSuppliers}
  invitedSuppliers={getSupplierData}
  itemLeaderboard={itemLeaderboard}
  auctionId={auctionId}
  firstQuote={formInputs?.firstQuote || false}
  firstQuoteBy={formInputs?.firstQuoteBy || "Supplier"}
  supplierInitialPrices={formInputs?.supplierInitialPrices || {}}
  supplierList={formInputs?.supplierList || getSupplierData || []}
  startPrice={formInputs?.startPrice || false}
  itemPrices={formInputs?.itemPrices || {}}
  itemReservePrice={formInputs?.itemReservePrice || {}}
  serverRemainingSeconds={serverRemainingSeconds}
  isAuctionClosed={isAuctionClosed}
/>
            </Row>

            <Row className="mb-4">
              <Col xs={12}>
                <BidSubmitPanel
                  auctionItems={formInputs?.items || []}
                  mbdType={formInputs?.mbdType || "anyAmount"}
                  mbdValue={parseFloat(formInputs?.mbdValue) || 0}
                  startPrice={formInputs?.startPrice || false}
                  itemPrices={formInputs?.itemPrices || {}}

                  fractions={formInputs?.fractions || "2"}
                  auctionStatus={socketAuctionStatus}
                  isConnected={socketConnected}
                  auctionId={auctionId}
                  liveBidRanking={liveBidRanking}
                  auctionMode={formInputs?.auctionType}
                  bidConfigType={formInputs?.bidConfigType || "parallel"}
                  bidTimings={formInputs?.bidTimings || {}}
                  itemLeaderboard={itemLeaderboard}
                  userRole="buyer"
                  serverRemainingSeconds={serverRemainingSeconds}
                  itemMbd={formInputs?.itemMbd || {}}
                  itemReservePrice={formInputs?.itemReservePrice || {}}
                  isAuctionClosed={isAuctionClosed}
                />
              </Col>
            </Row>

         

            {/* 
                Tab Navigation
             */}
            <div style={{ marginBottom: "18px", width: "100%" }}>
              <ul style={{ display: "flex", listStyle: "none", padding: 0, margin: 0, gap: "6px", overflowX: "auto", width: "100%" }}>
                {tabLabels.map((tab) => (
                  <li key={tab.id} style={{ flex: 1, minWidth: "85px" }}>
                    <button
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        width: "100%",
                        padding: "5px 6px",
                        border: activeTab === tab.id ? "2px solid #0f766e" : "1px solid #8fb5b1",
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #b7d8d5, #9fc7c3)",
                        color: activeTab === tab.id ? "#0f172a" : "#374151",
                        cursor: "pointer",
                        fontWeight: activeTab === tab.id ? "700" : "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "2px",
                        boxShadow: activeTab === tab.id
                          ? "0 2px 8px rgba(15,118,110,0.15)"
                          : "0 1px 4px rgba(0,0,0,0.06)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className={`bi ${tab.icon}`} style={{ fontSize: "14px", color: activeTab === tab.id ? "#0f766e" : "#475569" }}></i>
                      <span>{tab.id}. {tab.label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/*  TAB 1: Auction Creation  */}
            <div style={{ display: activeTab === 1 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"}`} onClick={toggleCardVisibility2}></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">EC</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Event Creation</span>
                        <span className="subHeaderTitle">Basic Auction Information</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <ComboboxField
                            label="Auction Type"
                            placeholder="Select Auction Type"
                            data={auctionTypeOptions}
                            id="auctionType"
                            iconClassName="dropdownIcon"
                            name="auctionType"
                            code="auctionType"
                            setValue={formInputs?.auctionType || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                          />
                          {formInputs?.auctionType && (
                            <small style={{ color: "#6b7280", fontSize: "11px" }}>
                              {formInputs.auctionType === "Reverse"
                                ? "📉 Bids go lower — lowest bid wins"
                                : "📈 Bids go higher — highest bid wins"}
                            </small>
                          )}
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <InputField
                            className="inputBox"
                            label="Auction Title"
                            name="auctionTitle"
                            id="auctionTitle"
                            value={formInputs?.auctionTitle || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <ComboboxField
                            className="inputBox"
                            label="Auction Category / Department"
                            data={buyerCategories}
                            name="buyerCategory"
                            id="buyerCategory"
                            setValue={formInputs?.buyerCategory || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <MultiselectField
                            label="Auction Currency"
                            placeholder="Please select the Auction Currency"
                            data={getcurrency}
                            id="auctionCurrencies"
                            iconClassName="dropdownIcon"
                            name="auctionCurrencies"
                            setValue={formInputs?.auctionCurrencie || []}
                            getvalue={setDropdownData}
                            className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <MultiselectField
                            label="Other Currency"
                            placeholder="Please select the Other Currencies"
                            data={getcurrency}
                            id="othercurrencies"
                            iconClassName="dropdownIcon"
                            name="othercurrencies"
                            setValue={formInputs?.othercurrencie || []}
                            getvalue={setDropdownData}
                            className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`} onClick={toggleCardVisibility5}></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Terms & Conditions</span>
                        <span className="subHeaderTitle">Terms & Conditions</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
                          <TextAreaField
                            className="inputBox"
                            label="Terms & Conditions"
                            name="auctionDescription"
                            id="auctionDescription"
                            value={formInputs?.auctionDescription || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex align-items-center">
                          <label style={{ ...labelStyle, marginRight: "8px" }}>Event Document</label>
                          <div className="d-flex align-items-center">
                            {formInputs?.eventDocument ? (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() => handleViewFile(formInputs?.eventDocument)}
                                style={{ cursor: "pointer" }}
                              />
                            ) : "--"}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 2: Configuration  */}
            <div style={{ display: activeTab === 2 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn"></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CF</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Auction Configuration</span>
                        <span className="subHeaderTitle">Bidding rules and display settings</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "16px", padding: "8px 0 16px" }}>
                        
                        {/* NEW: Bid Configuration Type */}
                        <LiveConfigCard
                          icon="bi-shuffle"
                          iconColor="#7c3aed"
                          iconBg="#ede9fe"
                          title="Bid Configuration Type"
                          hint={
                            formInputs?.bidConfigType === "parallel"
                              ? "All items can be bid simultaneously"
                              : formInputs?.bidConfigType === "serial"
                                ? "Items bid one after another sequentially"
                                : "Items bid with time intervals between them"
                          }
                        >
                          <div style={{ padding: "7px 12px", borderRadius: "6px", background: "#f0fdf9", border: "1.5px solid #99d4cf", fontSize: "13px", fontWeight: 600, color: "#0f766e", display: "inline-block" }}>
                            {formInputs?.bidConfigType === "parallel" ? "Parallel" : formInputs?.bidConfigType === "serial" ? "Serial" : formInputs?.bidConfigType === "staggered" ? "Staggered" : formInputs?.bidConfigType || "--"}
                          </div>
                        </LiveConfigCard>

                        {/* NEW: Time Interval (only for Staggered) */}
                        {formInputs?.bidConfigType === "staggered" && (
                          <LiveConfigCard
                            icon="bi-hourglass-split"
                            iconColor="#f59e0b"
                            iconBg="#fef3c7"
                            title="Time Interval"
                            hint="Minutes between each item's bid period"
                          >
                            <div style={{ padding: "7px 12px", borderRadius: "6px", background: "#fffbeb", border: "1.5px solid #fde68a", fontSize: "13px", fontWeight: 600, color: "#d97706", display: "inline-block" }}>
                              {formInputs?.timeInterval || "--"} min
                            </div>
                          </LiveConfigCard>
                        )}

                        <LiveConfigCard
                          icon="bi-tag-fill"
                          iconColor="#0f766e"
                          iconBg="#ccfbf1"
                          title="Start Price"
                          hint={formInputs?.startPrice ? "FQ is auto-disabled when Start Price = Yes" : "Suppliers begin bidding from a defined price point"}
                        >
                          <LiveRadioDisplay
                            value={formInputs?.startPrice === true ? "Yes" : "No"}
                          />
                        </LiveConfigCard>

                        {/* NEW: First Quote By */}
                        <LiveConfigCard
                          icon="bi-chat-quote-fill"
                          iconColor={formInputs?.startPrice ? "#9ca3af" : "#7c3aed"}
                          iconBg={formInputs?.startPrice ? "#f3f4f6" : "#ede9fe"}
                          title="FQ (First Quote)"
                          hint={
                            formInputs?.startPrice ? "Disabled — Start Price is active" :
                            formInputs?.firstQuote ? (formInputs?.firstQuoteBy === "Supplier" ? "Suppliers enter their own initial quote" : "Buyer enters starting prices for each supplier") :
                            "Suppliers submit first quote before live bidding"
                          }
                          faded={formInputs?.startPrice}
                        >
                          <LiveRadioDisplay
                            value={formInputs?.firstQuote === true ? "Yes" : "No"}
                            faded={formInputs?.startPrice}
                          />
                          {formInputs?.firstQuote && !formInputs?.startPrice && (
                            <div style={{ marginTop: "8px", padding: "6px 10px", borderRadius: "4px", background: "#ecfdf5", border: "1px solid #6ee7b7", fontSize: "11px", color: "#0f766e", fontWeight: 600 }}>
                              {formInputs?.firstQuoteBy === "Supplier" ? "✓ Supplier enters quote" : "✓ Buyer enters prices"}
                            </div>
                          )}
                        </LiveConfigCard>

                        <LiveConfigCard
                          icon="bi-bar-chart-fill"
                          iconColor="#1d4ed8"
                          iconBg="#dbeafe"
                          title="Display Rank"
                          hint={
                            formInputs?.displayRank === "showToAll" ? "Each supplier sees their own current rank" :
                            formInputs?.displayRank === "onlyLeading" ? "Only L1 bidder sees rank; others see 'Any'" :
                            "Rank not shown to anyone"
                          }
                        >
                          <div style={{ padding: "7px 12px", borderRadius: "6px", background: "#f0fdf9", border: "1.5px solid #99d4cf", fontSize: "13px", fontWeight: 600, color: "#0f766e", display: "inline-block" }}>
                            {formInputs?.displayRank === "showToAll" ? "Show to All" :
                             formInputs?.displayRank === "onlyLeading" ? "Only Leading Bidder" :
                             formInputs?.displayRank === "notApplicable" ? "Not Applicable" :
                             formInputs?.displayRank || "--"}
                          </div>
                        </LiveConfigCard>

                        <LiveConfigCard
                          icon="bi-eye-slash-fill"
                          iconColor="#dc2626"
                          iconBg="#fee2e2"
                          title="Vendor / Supplier Masking"
                          hint={formInputs?.vendorMasking ? "Supplier names hidden from buyer until auction closes" : "Supplier names are visible to the buyer"}
                        >
                          <LiveRadioDisplay
                            value={formInputs?.vendorMasking === true ? "Yes" : "No"}
                          />
                        </LiveConfigCard>

                        <LiveConfigCard
                          icon="bi-bullseye"
                          iconColor="#0369a1"
                          iconBg="#e0f2fe"
                          title="Bid Against"
                          hint={
                            formInputs?.bidAgainst === "leadingPrice"
                              ? "All suppliers must beat the current L1 price (Leading Price - MBD)"
                              : "Each supplier bids against their own previous bid (Own Bid - MBD)"
                          }
                        >
                          <div style={{ display: "flex", gap: "8px" }}>
                            {[
                              { val: "leadingPrice", label: "Leading Price", activeColor: "#0369a1", activeBg: "#e0f2fe", activeBorder: "#7dd3fc" },
                              { val: "ownPrice",     label: "Own Price",     activeColor: "#7c3aed", activeBg: "#f5f3ff", activeBorder: "#c4b5fd" },
                            ].map((opt) => {
                              const isActive = formInputs?.bidAgainst === opt.val;
                              return (
                                <div key={opt.val} style={{
                                  flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                                  padding: "7px 12px", borderRadius: "8px",
                                  border: isActive ? `2px solid ${opt.activeBorder}` : "2px solid #e5e7eb",
                                  background: isActive ? opt.activeBg : "#fafafa",
                                  color: isActive ? opt.activeColor : "#9ca3af",
                                  fontWeight: isActive ? 700 : 400,
                                  fontSize: "13px",
                                }}>
                                  {isActive
                                    ? <i className="bi bi-check-circle-fill" style={{ fontSize: "12px" }}></i>
                                    : <i className="bi bi-circle" style={{ fontSize: "12px" }}></i>}
                                  {opt.label}
                                </div>
                              );
                            })}
                          </div>
                          <div style={{
                            marginTop: "8px", padding: "8px 12px", borderRadius: "7px", fontSize: "11px", lineHeight: 1.6,
                            background: formInputs?.bidAgainst === "leadingPrice" ? "#f0f9ff" : "#f5f3ff",
                            border: formInputs?.bidAgainst === "leadingPrice" ? "1px solid #bae6fd" : "1px solid #ddd6fe",
                            color: formInputs?.bidAgainst === "leadingPrice" ? "#0369a1" : "#6d28d9",
                          }}>
                            {formInputs?.bidAgainst === "leadingPrice" ? (
                              <><strong>Leading Price:</strong> Next bid {"<="} Current L1 Price - MBD.</>
                            ) : (
                              <><strong>Own Price:</strong> Next bid {"<="} Supplier's Own Last Bid - MBD.</>
                            )}
                          </div>
                        </LiveConfigCard>

                        <div style={{ gridColumn: "1 / -1" }}>
                          <LiveConfigCard
                            icon="bi-arrow-down-up"
                            iconColor="#d97706"
                            iconBg="#fef3c7"
                            title="Minimum Bid Difference (MBD) Type"
                            hint={
                              formInputs?.mbdType === "atLeastMbd" ? "Each new bid must differ by at least the MBD value" :
                              formInputs?.mbdType === "multiplesMbd" ? "Bids must be multiples of MBD (e.g. 10 → 20 → 30...)" :
                              "Any bid amount is accepted — no minimum gap enforced"
                            }
                          >
                            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                              {[
                                { val: "atLeastMbd", label: "At Least MBD", activeColor: "#d97706", activeBg: "#fffbeb", activeBorder: "#fde68a" },
                                { val: "multiplesMbd", label: "Multiples of MBD", activeColor: "#7c3aed", activeBg: "#f5f3ff", activeBorder: "#c4b5fd" },
                                { val: "anyAmount", label: "Any Amount", activeColor: "#059669", activeBg: "#ecfdf5", activeBorder: "#6ee7b7" },
                              ].map((opt) => {
                                const isActive = formInputs?.mbdType === opt.val;
                                return (
                                  <div key={opt.val} style={{
                                    display: "flex", alignItems: "center", gap: "8px",
                                    padding: "8px 16px", borderRadius: "8px",
                                    border: isActive ? `2px solid ${opt.activeBorder}` : "2px solid #e5e7eb",
                                    background: isActive ? opt.activeBg : "#f9fafb",
                                    color: isActive ? opt.activeColor : "#9ca3af",
                                    fontWeight: isActive ? 700 : 400,
                                    fontSize: "13px",
                                  }}>
                                    {opt.label}
                                    {isActive && <i className="bi bi-check2" style={{ fontSize: "12px", marginLeft: "4px" }}></i>}
                                  </div>
                                );
                              })}
                            </div>
                          </LiveConfigCard>
                        </div>

                        <LiveConfigCard
                          icon="bi-calculator-fill"
                          iconColor="#06b6d4"
                          iconBg="#cffafe"
                          title="Bid Type"
                          hint={formInputs?.bidType === "perUnit" ? "Suppliers bid per unit quantity" : "Suppliers bid for overall item amount"}
                        >
                          <div style={{ padding: "7px 12px", borderRadius: "6px", background: "#ecfdf5", border: "1.5px solid #99d4cf", fontSize: "13px", fontWeight: 600, color: "#0f766e", display: "inline-block" }}>
                            {formInputs?.bidType === "perUnit" ? "Per Unit" : formInputs?.bidType === "overall" ? "Overall" : formInputs?.bidType || "--"}
                          </div>
                        </LiveConfigCard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 3: Add Item  */}
            <div style={{ display: activeTab === 3 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`} onClick={toggleCardVisibility6}></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">IB</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Items For Bidding</span>
                        <span className="subHeaderTitle">Auction Item Details</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={lineItemsColumns}
                            data={getLineItemstData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 4: Suppliers  */}
            <div style={{ display: activeTab === 4 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible7 ? "bi-chevron-right" : "bi-chevron-down"}`} onClick={toggleCardVisibility7}></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BR</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Bidders / Suppliers</span>
                        <span className="subHeaderTitle">Invited Supplier List</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={suppliersColumns}
                            data={getSupplierData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"}`} onClick={toggleCardVisibility10}></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BD</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Bidder Details</span>
                        <span className="subHeaderTitle">Contact and User Information</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={biddersColumns}
                            data={getBiddersData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 5: Price  */}
            <div style={{ display: activeTab === 5 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn"></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PR</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Price Configuration</span>
                        <span className="subHeaderTitle">Line items, MBD amount, fractions, reserve price, and bid timings</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">

                        {/* Line items with NEW columns */}
                        <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
                          <label style={labelStyle}>
                            Line Items{" "}
                            {formInputs?.startPrice && (
                              <span style={{ color: "#1d4ed8" }}>(Start Price per item)</span>
                            )}
                          </label>
                          <DataTable
                            columns={priceConfigColumns}
                            data={getLineItemstData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                            noDataComponent="No items added."
                          />
                        </Col>

                        {/* NEW: Bid Type display */}
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                          <ReadonlyField
                            label="Bid Type"
                            value={formInputs?.bidType === "perUnit" ? "Per Unit" : formInputs?.bidType === "overall" ? "Overall" : formInputs?.bidType}
                          />
                        </Col>

                        {/* MBD Value */}
                        {formInputs?.mbdType !== "anyAmount" && (
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                            <ReadonlyField
                              label={`MBD Amount (${formInputs?.mbdType === "atLeastMbd" ? "At Least" : "Multiples of"})`}
                              value={formInputs?.mbdValue}
                            />
                            {formInputs?.mbdType === "multiplesMbd" && formInputs?.mbdValue && (
                              <small style={{ color: "#6b7280", fontSize: "11px" }}>
                                Valid: {formInputs.mbdValue}, {Number(formInputs.mbdValue) * 2}, {Number(formInputs.mbdValue) * 3}...
                              </small>
                            )}
                          </Col>
                        )}

                        {/* NEW: Number of Fractions */}
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                          <ReadonlyField
                            label="Number of Fractions"
                            value={
                              formInputs?.fractions === "0" ? "0 Decimal" :
                              formInputs?.fractions === "1" ? "1 Decimal" :
                              formInputs?.fractions === "2" ? "2 Decimals" :
                              formInputs?.fractions === "3" ? "3 Decimals" :
                              formInputs?.fractions === "4" ? "4 Decimals" :
                              formInputs?.fractions
                            }
                          />
                        </Col>

                        {/* Reserve Price */}
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mt-3">
                          <ReadonlyField label="Reserve Price" value={formInputs?.reservePrice} />
                        </Col>

                        {/* NEW: Bid Timing Information (for Serial/Staggered) */}
                        {formInputs?.bidConfigType !== "parallel" && getLineItemstData.length > 0 && (
                          <Col xs={12} className="commTopButtonRightLeftPadding mt-3">
                            <div style={{
                              background: "#e0f2fe",
                              border: "1px solid #bae6fd",
                              borderRadius: "6px",
                              padding: "12px 16px",
                              fontSize: "12px",
                              color: "#0369a1",
                            }}>
                              <strong>⏱️ Bid Timing Configuration ({formInputs.bidConfigType === "serial" ? "Serial (Lot-wise)" : "Staggered (Interval)"})</strong>
                              {formInputs.bidConfigType === "staggered" && formInputs.timeInterval && (
                                <div style={{ marginTop: "6px", color: "#0369a1", fontSize: "11px" }}>
                                  📌 Each item closes <strong>{formInputs.timeInterval} min</strong> after the previous one
                                </div>
                              )}
                              {formInputs.bidConfigType === "serial" && (
                                <div style={{ marginTop: "6px", color: "#0369a1", fontSize: "11px" }}>
                                  📌 Items run sequentially by Lot No in the table above
                                </div>
                              )}
                              <table style={{ width: "100%", marginTop: "10px", borderCollapse: "collapse" }}>
                                <thead>
                                  <tr style={{ borderBottom: "1px solid #bae6fd" }}>
                                    <th style={{ textAlign: "left", paddingBottom: "6px", fontSize: "11px", fontWeight: 600 }}>
                                      {formInputs.bidConfigType === "serial" ? "Lot No" : "Seq"}
                                    </th>
                                    <th style={{ textAlign: "left", paddingBottom: "6px", fontSize: "11px", fontWeight: 600 }}>Item</th>
                                    <th style={{ textAlign: "left", paddingBottom: "6px", fontSize: "11px", fontWeight: 600 }}>Start Time</th>
                                    <th style={{ textAlign: "left", paddingBottom: "6px", fontSize: "11px", fontWeight: 600 }}>End Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {getLineItemstData.map((item) => {
                                    const timing = formInputs.bidTimings?.[item.local_id];
                                    return (
                                      <tr key={item.local_id} style={{ borderBottom: "1px solid #e0f2fe" }}>
                                        <td style={{ paddingTop: "6px", paddingBottom: "6px", fontWeight: 700, color: "#0f766e" }}>
                                          {formInputs.bidConfigType === "serial"
                                            ? (timing?.lotNumber ?? "--")
                                            : (timing?.serialNumber ?? "--")}
                                        </td>
                                        <td style={{ paddingTop: "6px", paddingBottom: "6px" }}>
                                          {item.itemNo || item.itemCode || `Item ${item.local_id}`}
                                        </td>
                                        <td style={{ paddingTop: "6px", paddingBottom: "6px" }}>
                                          {timing?.startTime
                                            ? new Date(timing.startTime).toLocaleString("en-IN", { hour12: true, hour: "2-digit", minute: "2-digit", day: "2-digit", month: "short" })
                                            : "--"}
                                        </td>
                                        <td style={{ paddingTop: "6px", paddingBottom: "6px", color: "#dc2626", fontWeight: 600 }}>
                                          {timing?.endTime
                                            ? new Date(timing.endTime).toLocaleString("en-IN", { hour12: true, hour: "2-digit", minute: "2-digit", day: "2-digit", month: "short" })
                                            : "--"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        )}

                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 6: Schedule  */}
            <div style={{ display: activeTab === 6 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn"></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SC</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Auction Schedule</span>
                        <span className="subHeaderTitle">Start/end time and auto-extension rules</span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">

                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <InputField
                            className="inputBox"
                            label="Start Date"
                            name="openingDate"
                            id="openingDate"
                            type="date"
                            value={getOpenCloseInput.openingDate || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <InputField
                            className="inputBox"
                            label="Start Time"
                            name="openingTime"
                            id="openingTime"
                            type="time"
                            value={getOpenCloseInput.openingTime || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <InputField
                            className="inputBox"
                            label="End Date"
                            name="closingDate"
                            id="closingDate"
                            type="date"
                            value={getOpenCloseInput.closingDate || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>
                        <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                          <InputField
                            className="inputBox"
                            label="End Time"
                            name="closingTime"
                            id="closingTime"
                            type="time"
                            value={getOpenCloseInput.closingTime || ""}
                            onChange={() => {}}
                            disabled={true}
                          />
                        </Col>

                        {/* NEW: Auto Extension – read only */}
                        <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding mt-3">
                          <label style={labelStyle}>Auto Extension Logic</label>
                          <Row>
                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              <ReadonlyField
                                label="Extend if bid received in last"
                                value={formInputs?.newBidReceived || "Not Applicable"}
                              />
                            </Col>
                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              <ReadonlyField
                                label="Extension Duration"
                                value={
                                  formInputs?.auctionAutoExtended
                                    ? `${formInputs.auctionAutoExtended} minute(s)`
                                    : "--"
                                }
                              />
                            </Col>
                            <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                              <ReadonlyField
                                label="Number of Extension Cycles"
                                value={formInputs?.extensionCycles}
                              />
                            </Col>
                          </Row>
                        </Col>

                        {/* Total Duration info */}
                        {getOpenCloseInput.openingDate && getOpenCloseInput.closingDate && (
                          <Col xs={12} className="commTopButtonRightLeftPadding mt-3">
                            <div style={{
                              background: "#eff6ff",
                              border: "1px solid #bfdbfe",
                              borderRadius: "6px",
                              padding: "12px 16px",
                              fontSize: "12px",
                              color: "#1e40af",
                            }}>
                              <strong>📅 Auction Window:</strong>{" "}
                              {getOpenCloseInput.openingDate} {getOpenCloseInput.openingTime} →{" "}
                              {getOpenCloseInput.closingDate} {getOpenCloseInput.closingTime}
                            </div>
                          </Col>
                        )}

                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  Tab Prev / Next Navigation  */}
            <Row className="justify-content-end">
              <Col xs={12} md={4} lg={4} className="mb-2">
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "16px", marginBottom: "16px" }}>
                  <button
                    className="btnTable"
                    onClick={() => setActiveTab((prev) => Math.max(1, prev - 1))}
                    disabled={activeTab === 1}
                    style={{ opacity: activeTab === 1 ? 0.4 : 1 }}
                  >
                    ← Previous
                  </button>
                  <span style={{ fontSize: "12px", color: "#6b7280", alignSelf: "center" }}>
                    Step {activeTab} of {totalTabs}
                  </span>
                  <button
                    className="btnTable"
                    onClick={() => setActiveTab((prev) => Math.min(totalTabs, prev + 1))}
                    disabled={activeTab === totalTabs}
                    style={{ opacity: activeTab === totalTabs ? 0.4 : 1 }}
                  >
                    Next →
                  </button>
                </div>
              </Col>
            </Row>

          </div>
        </Col>
      </Row>

      {/*  Modals  */}
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={hideSuccessModal}
        modaldata={getModalInfo}
        aftersuccess={Constants.EAUCTION_BUYERAUCTION_LIST}
      />
      <BuyerAuctionFormModal
        show={getCreateDynamicformModelShow}
        onHide={hideModalStatus}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={hideFailureModal}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={itemLevelHideModal}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

//  LiveConfigCard — read-only settings card 
const LiveConfigCard = ({ icon, iconColor, iconBg, title, hint, faded, children }) => (
  <div style={{
    background: "#fff",
    border: "1.5px solid #e5e7eb",
    borderRadius: "10px",
    padding: "16px 18px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    opacity: faded ? 0.45 : 1,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div style={{
        width: "32px", height: "32px", borderRadius: "8px",
        background: iconBg, display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
      }}>
        <i className={`bi ${icon}`} style={{ fontSize: "14px", color: iconColor }}></i>
      </div>
      <div>
        <div style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b", lineHeight: 1.2 }}>{title}</div>
        {hint && <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>{hint}</div>}
      </div>
    </div>
    <div>{children}</div>
  </div>
);

//  LiveRadioDisplay — read-only pill for Yes/No values 
const LiveRadioDisplay = ({ value, faded }) => {
    //eslint-disable-next-line
  const isYes = value === "Yes";
  return (
    <div style={{ display: "flex", gap: "8px", opacity: faded ? 0.5 : 1 }}>
      {["Yes", "No"].map((v) => {
        const isActive = value === v;
        const activeColor  = v === "Yes" ? "#059669" : "#6b7280";
        const activeBg     = v === "Yes" ? "#ecfdf5" : "#f3f4f6";
        const activeBorder = v === "Yes" ? "#6ee7b7" : "#d1d5db";
        return (
          <div key={v} style={{
            display: "flex", alignItems: "center", gap: "6px",
            padding: "5px 14px", borderRadius: "20px",
            border: isActive ? `2px solid ${activeBorder}` : "2px solid #f3f4f6",
            background: isActive ? activeBg : "#fafafa",
            color: isActive ? activeColor : "#d1d5db",
            fontWeight: isActive ? 700 : 400,
            fontSize: "13px",
          }}>
            <i className={`bi ${isActive ? (v === "Yes" ? "bi-check-circle-fill" : "bi-x-circle-fill") : "bi-circle"}`}
              style={{ fontSize: "12px" }}></i>
            {v}
          </div>
        );
      })}
    </div>
  );
};

export default LiveReverseAuctionDetail;
